import { useReadQuery } from '@apollo/client';
import { createContext, ReactNode, useContext } from 'react';
import { TerminalTabsQueryQuery } from '@/__generated__/graphql';
import { TerminalTab } from '@/__generated__/schema-types.ts';
import { useAuthenticatedAppLoader } from '@/routes/_app/loader';
import { CRYPTO_TAB_PRESET_CONFIGURATION } from './terminal/constants/crypto-tab-preset';

// The two tabs the signup lambda creates, so guests see the default layout.
// oxlint-disable-next-line react/only-export-components
export const GUEST_TERMINAL_TABS: TerminalTab[] = [
  { id: 'guest-prediction', name: 'Prediction', configuration: null },
  {
    id: 'guest-crypto',
    name: 'Crypto',
    configuration: CRYPTO_TAB_PRESET_CONFIGURATION,
  },
];

// oxlint-disable-next-line react/only-export-components
export const useAuthenticatedTerminalTabs = () => {
  const data = useAuthenticatedAppLoader();

  const {
    data: { terminalTabs },
  } = useReadQuery<TerminalTabsQueryQuery>(data.terminalTabsQueryRef);

  return (terminalTabs || []) as TerminalTab[];
};

const TerminalTabsContext = createContext<TerminalTab[] | null>(null);

export const AuthenticatedTerminalTabsProvider = ({
  children,
}: {
  children: ReactNode;
}) => (
  <TerminalTabsContext.Provider value={useAuthenticatedTerminalTabs()}>
    {children}
  </TerminalTabsContext.Provider>
);

export const GuestTerminalTabsProvider = ({
  children,
}: {
  children: ReactNode;
}) => (
  <TerminalTabsContext.Provider value={GUEST_TERMINAL_TABS}>
    {children}
  </TerminalTabsContext.Provider>
);

// oxlint-disable-next-line react/only-export-components
export const useTerminalTabs = () => {
  const tabs = useContext(TerminalTabsContext);
  if (!tabs) {
    throw new Error('useTerminalTabs must be used within a terminal layout');
  }
  return tabs;
};
